import { useEffect } from 'react';
import PropTypes from 'prop-types';
import SnackbarSystem from '@ui/systems/SnackbarSystem';

import { getWorkspaceLabelGroups } from '../../selectors/labelGroups';
import { connectComponent } from '../../lib/connectComponent';
import WorkspaceLabelGroups from '../../components/WorkspaceLabelGroups/WorkspaceLabelGroups';
import WorkspaceSystem from '../../systems/WorkspaceSystem';
import PopupSystem from '../../systems/PopupSystem';
import AsyncActionPresenterFactory from '../../factories/AsyncActionPresenterFactory';

export const WorkspaceLabelGroupsContainer = ( {
	workspaceID, labelGroups, workspaceSystem, popupSystem, snackbarSystem
} ) => {
	useEffect( () => {
		workspaceSystem.getLabelGroups( workspaceID );
	}, [ workspaceID ] );

	const onDeleteGroupClick = ( labelGroup ) => {
		AsyncActionPresenterFactory.forDeleteLabelGroup( {
			workspaceID, labelGroup, workspaceSystem, popupSystem, snackbarSystem
		} ).trigger();
	}

	return (
		<WorkspaceLabelGroups
			workspaceID={workspaceID}
			labelGroups={labelGroups}
			onDeleteGroupClick={onDeleteGroupClick}
		/>
	);
}

WorkspaceLabelGroupsContainer.propTypes = {
	workspaceID: PropTypes.number,
	labelGroups: PropTypes.shape( {
		workspace_label_groups: PropTypes.arrayOf( PropTypes.shape( {
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
			groupType: PropTypes.string.isRequired,
			labels: PropTypes.arrayOf( PropTypes.shape( {
				id: PropTypes.number.isRequired,
				name: PropTypes.string.isRequired,
				baseColor: PropTypes.string.isRequired,
				hoverColor: PropTypes.string.isRequired
			} ) ).isRequired
		} ) ).isRequired,
		project_label_groups: PropTypes.arrayOf( PropTypes.shape( {
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
			groupType: PropTypes.string.isRequired,
			labels: PropTypes.arrayOf( PropTypes.shape( {
				id: PropTypes.number.isRequired,
				name: PropTypes.string.isRequired,
				baseColor: PropTypes.string.isRequired,
				hoverColor: PropTypes.string.isRequired
			} ) ).isRequired
		} ) ).isRequired
	} ),
	workspaceSystem: PropTypes.instanceOf( WorkspaceSystem ).isRequired,
	popupSystem: PropTypes.instanceOf( PopupSystem ).isRequired,
	snackbarSystem: PropTypes.instanceOf( SnackbarSystem ).isRequired
};

WorkspaceLabelGroupsContainer.defaultProps = {
	workspaceID: undefined,
	labelGroups: { workspace_label_groups: [], project_label_groups: [] }
};

export default connectComponent( ( state, props ) => ( {
	labelGroups: getWorkspaceLabelGroups( state, props )
} ) )( WorkspaceLabelGroupsContainer );
